import React from 'react'

import { bool, func } from 'prop-types'

import EssentialsTagIcon from 'Pods/Shared/Icons/EssentialsTagIcon'

const PROMO_DESCRIPTION = ' - Earn passive income when subscribers download your models.'
  + ' Just enable Maximize Earnings to get started.'

function EssentialsBanner({ isParticipating = false, onHowItWorks }) {
  const modifierClass = isParticipating
    ? 'overview-essentials-banner--joined'
    : 'overview-essentials-banner--promo'

  return (
    <div className={`overview-essentials-banner ${modifierClass}`}>
      <EssentialsTagIcon />
      <div className="cgt-text-medium">
        {isParticipating ? (
          <span>
            You are participating in{' '}
            <span className="cgt-heading-h6">Maximize Earnings</span>
            {' '}program.
          </span>
        ) : (
          <span>
            <span className="cgt-heading-h6">CGTrader Essentials</span>
            {PROMO_DESCRIPTION}
          </span>
        )}
      </div>
      <button
        type="button"
        className="cgt-link-primary overview-essentials-banner__how-it-works"
        onClick={onHowItWorks}
      >
        How it works
      </button>
    </div>
  )
}

EssentialsBanner.propTypes = {
  isParticipating: bool,
  onHowItWorks: func.isRequired,
}

export default EssentialsBanner
